export default class Logger {

  static #rawConsoleLogs(dump) {
    if (dump === null) {
      console.log('null');
    } else if (typeof dump === 'object') {
      try {
        console.log(JSON.stringify(dump));
      } catch (warning) {
        console.warn(warning);
      }
    } else if (typeof dump.toString !== 'undefined') {
      console.log(dump.toString());
    }
  }

  static print(type, data, dump, dump2) {

    const consoleStyleRmp = 'color: white; background-color: #3949AB; padding:1px 3px; border-radius: 3px; margin-right: 7px; text-transform: uppercase;';
    const consoleStyleInfo = 'color: white; background-color: #0091EA; padding:1px 3px; border-radius: 3px; margin-right: 7px; text-transform: uppercase;';
    const consoleStyleIma = 'color: white; background-color: #00ACC1; padding:1px 3px; border-radius: 3px; margin-right: 7px; text-transform: uppercase;';
    const consoleStyleWarning = 'color: white; background-color: #FF6D00; padding:1px 3px; border-radius: 3px; margin-right: 7px; text-transform: uppercase;';
    const consoleStyleError = 'color: white; background-color: #D50000; padding:1px 3px; border-radius: 3px; margin-right: 7px; text-transform: uppercase;';

    if (window.rmpGlobals.forceRawConsoleLogs) {
      if (data) {
        console.log(type.toUpperCase() + ': ' + data);
      }
      if (typeof dump !== 'undefined') {
        Logger.#rawConsoleLogs(dump);
      }
      if (typeof dump2 !== 'undefined') {
        Logger.#rawConsoleLogs(dump2);
      }
    } else {
      if (data) {
        if (type) {
          switch (type) {
            case 'warning':
              console.warn('%crmp%c' + type + '%c' + data, consoleStyleRmp, consoleStyleWarning, '');
              break;
            case 'error':
              console.error('%crmp%c' + type + '%c' + data, consoleStyleRmp, consoleStyleError, '');
              break;
            case 'google-ima':
            case 'google-ima-dai':
              console.log('%crmp%c' + type + '%c' + data, consoleStyleRmp, consoleStyleIma, '');
              break;
            default:
              console.log('%crmp%c' + type + '%c' + data, consoleStyleRmp, consoleStyleInfo, '');
              break;
          }
        }
      }
      if (dump) {
        console.log(dump);
      }
      if (dump2) {
        console.log(dump2);
      }
    }
  }

}
